import React from "react";
import {BonusOfferService} from "../../services/BonusOfferService";
import {getContainer} from "../../ioc/IOCSetup";
import {BonusConfigService} from "../../services/BonusConfigService";
import {Form, FormListener} from "../form/Form";
import {AwardBonusOfferRequest, BonusConfig, BonusConfigListRequest, BonusStatus, BonusVisibilityStatus} from "../../http/protocol";
import {Collapsible} from "../Collapsible";
import {SelectInput} from "../form/SelectInput";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {Submit} from "../form/Submit";
import {FormInput} from "../form/FormInput";

interface State {
    form:AwardBonusOfferRequest;
    validationMap: any;
    configs: BonusConfig[];
    selectedBonus: BonusConfig;
    bonusConfigListRequest: BonusConfigListRequest;

}

interface Props {
    userId:number;
}

export class UserBonusComponent extends React.Component<Props, State> implements FormListener<AwardBonusOfferRequest>{
    bonusAwardService:BonusOfferService;
    bonusConfigService:BonusConfigService;
    constructor(props:Props) {
        super(props);
        this.bonusAwardService = getContainer().getBonusOfferService();
        this.bonusConfigService = getContainer().getBonusConfigService();
        this.state = { form : {}, validationMap : {}, configs: [], selectedBonus:{}, bonusConfigListRequest: {bonusVisibilityStatus: BonusVisibilityStatus.NON_ARCHIVED, status: BonusStatus.ENABLED, ascending: false, orderBy:'id', limit:100}};

    }

    componentDidMount() {
        this.bonusConfigService.list(this.state.bonusConfigListRequest).then((resp) => {
            if(resp.items && resp.items.length > 0) {
                let bonuses:BonusConfig[] = [];
                
                resp.items.forEach((bonus) => {
                    if(bonus.status === "ENABLED") {
                        bonuses.push(bonus)
                    }
                })
                const bonusConfigId = (bonuses && bonuses[0] && bonuses[0].id) || null;
                const initForm = this.state.form;
                if(bonusConfigId != null) {initForm.bonusConfigId = bonusConfigId}
                this.setState({configs:bonuses, form:initForm, selectedBonus:bonuses[0]})
            }
        })
    }

    formDidUpdate(formModel: AwardBonusOfferRequest, validationMap?: any) {
        formModel.userId = this.props.userId;
        const bonusConfig:BonusConfig = this.state.configs.find(bonus => bonus.id === formModel.bonusConfigId) ||{};
        this.setState({form : formModel, validationMap : validationMap, selectedBonus:bonusConfig});
    }

    onSubmit() {
        return this.bonusAwardService.awardUserBonus(this.state.form).then((result) => {
        }).catch(err=>{
            throw err.message;
        });
    }

    toDisplayValue(a : BonusConfig){
        if(a.name)
        {
            return a.name.toString();
        } else {

            return "";
        }
    }

    getBonusDetails() {
        if(this.state.selectedBonus && this.state.selectedBonus.monetaryConfig) {
            const conf = this.state.selectedBonus.monetaryConfig;
            return (
                <tbody>
                <tr>
                    <td>Balance</td>
                    <td>{ `${conf.awardTarget} ${conf.currencyCode} `}</td>
                    <span></span>
                </tr>
                <tr>
                    <td>Award Amount Fraction</td>
                    <td>{conf.awardAmountFraction}</td>
                    <span className="help-block">Multiplied with the input amount (ie deposit amount) to set how much bonus the player will receive. If set to 2 the user will receive 200% bonus.</span>
                </tr>
                <tr>
                    <td>Turnover Amount Factor</td>
                    <td>{conf.turnoverRequirementFactor}</td>
                    <span className="help-block">How many times the bonus a player is awarded he needs to turnover the bonus for it to be completed</span>
                </tr>
                </tbody>
            )
        } else {
            return <tbody/>;

        }
    }


    getForm() {
        let amount = this.state.form.amount && this.state.selectedBonus.monetaryConfig && this.state.selectedBonus.monetaryConfig.awardAmountFraction && (this.state.form.amount * this.state.selectedBonus.monetaryConfig.awardAmountFraction)
        return(
            <Form className="manual-adjustment-form container-fluid" formListener={this} validationMap={this.state.validationMap} modelObject={this.state.form}>
                <div className="row">
                    <div className="col-sm-12">
                        <label>Bonus Config</label>
                        <SelectInput className="form-control" model="bonusConfigId" values={this.state.configs} displayValue={this.toDisplayValue} optionModelValue={ (a : BonusConfig)=> { return a.id; }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                    <label style={{paddingTop:"10px"}}>Bonus Details</label>
                    <table className={"table table-striped"}>
                        {this.getBonusDetails()}
                    </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <label>Input Amount</label>
                        <FormInput className="form-control" model="amount" type="number"/>
                        <span className="help-block">The total bonus amount awarded will be this amount multiplied with the Award Amount Fraction.</span>
                    </div>
                    <div className="col-sm-6">
                        <label>&nbsp;</label>
                        <FormSubmitError />
                        <FormSubmitSuccess text={"Bonus awarded to player!"}/>
                        <Submit className="btn btn-primary btn-block">Award {amount} {this.state.form.amount && this.state.form.amount >= 0 && this.state.selectedBonus.monetaryConfig && this.state.selectedBonus.monetaryConfig.currencyCode}</Submit>
                    </div>
                </div>
            </Form>
        )

    }

    render() {
        return(
            <Collapsible title="Manual Bonus Award" collapsed={true}>
                {this.getForm()}
            </Collapsible>
        )
    }
}